<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <h4>Edição de Atividade</h4>
                </div>
            </div>

            <form @submit.prevent="submit" ref="addItem">  
                <div class="row">
                    <form-input
                        v-model="atividade.atividade"
                        label="Atividade:"
                        required
                    />
                    <form-input
                        v-model="atividade.frequencia"
                        label="Frequência:"
                        grid="6"
                        required
                    />
                    <form-input
                        v-model="atividade.local"
                        label="Local da atividade:"
                        grid="6"
                        required
                    />
                    <form-input
                        v-model="atividade.objetivo"
                        label="Objetivo:"
                        required
                    />
                    <form-input
                        v-model="atividade.data_atividade"
                        label="Data:"
                        grid="6"
                        type="date"
                        required
                    />
                    <form-input
                        v-model="atividade.hora_atividade"
                        label="Hora:"
                        grid="6"
                        type="time"
                        required
                    />
                    <form-select
                      v-model="atividade.status"
                      label="Status:"
                      grid="6"
                      :itens="statusOptions"
                    />

                </div>
                
                <div class="d-flex gap-2 justify-content-end">
                    <b-button size="sm" variant="secondary" @click="historicoStatus = true">
                        <i class="fas fa-history"></i> Histórico de Status
                    </b-button>

                    <b-button size="sm" variant="success" type="submit">
                        Editar informações
                    </b-button>

                    <b-button size="sm" variant="primary" @click="imprimirAtividade()" v-b-tooltip.hover :title="$t('Visualizar e Imprimir')">
                        <i class="mdi mdi-printer mdi-18px" />
                    </b-button>
                </div>

                <div v-if="historicoStatus" class="mt-4">
                    <h5 class="mb-3">Histórico de Status da Atividade</h5>

                    <table class="table table-striped table-bordered">
                        <thead style="background-color: #5895FF; color: white !important;">
                            <tr>
                                <th>Status Anterior</th>
                                <th>Status Atual</th>
                                <th>Motivo</th>
                                <th>Alterado Por</th>
                                <th>Data da Alteração</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(registro, index) in historico" :key="index">
                                <td>{{ registro.status_anterior || '-' }}</td>
                                <td>{{ registro.status_atual || '-' }}</td>
                                <td>{{ registro.motivo_finalizacao || '-' }}</td>
                                <td>{{ registro.nome_usuario || '-' }}</td>
                                <td>{{ formatarDataHora(registro.created_at) }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="d-flex justify-content-end">
                        <button class="btn btn-secondary mt-2" @click="historicoStatus = false">
                        Fechar histórico
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item", "atividade"],
    data() {
        return {
            form: { ...this.atividade },
            statusOptions: [
                { id: 'Aberto', value: 'Aberto' },
                { id: 'Em andamento', value: 'Em andamento' },
                { id: 'Cancelado', value: 'Cancelado' },
                { id: 'Realizado', value: 'Realizado' },
                { id: 'Finalizado', value: 'Finalizado' },
                { id: 'Inativo', value: 'Inativo' }
            ],
            historicoStatus: false,
            historico: [],
        };
    },
    watch: {
        historicoStatus(novo) {
            if (novo) {
                this.carregarHistorico();
            }
        }
    },
    methods: {
        imprimirAtividade() {

            const atividadeId = this.atividade?.id; // pega o id do objeto atividade

            if (!atividadeId) {
                this.$snack.warning({ text: "Não foi possível identificar a atividade para impressão." });
                return;
            }

            this.$router.push({
                path: `/dashboard/acolhimento/idoso/atividades/${atividadeId}`
            });

        },
        async carregarHistorico() {
            try {
                const response = await axios.get(`/api/dashboard/acolhimento/idoso/atividades/${this.atividade.id}/historico`);
                this.historico = response.data || [];
            } catch (error) {
                this.$snack.error({ text: "Erro ao carregar histórico de status." });
            }
        },
        formatarDataHora(data) {
            if (!data) return '-';
            const d = new Date(data);
            return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        },
        async submit() {
            const camposObrigatorios = [
                'atividade', 'frequencia', 'local', 'objetivo',
                'data_atividade', 'hora_atividade'
            ];

            for (let campo of camposObrigatorios) {
                if (!this.atividade[campo]) {
                    this.$snack.warning({ text: 'Preencha todos os campos obrigatórios.' });
                    return;
                }
            }

            const payload = {
                ...this.atividade,
                acolhimento_id: this.item.id,
            };

            try {
                const response = await axios.post(`api/dashboard/acolhimento/idoso/atividades/update/${payload.id}`, payload);
                const idAtividade = response?.data?.id;

                if (idAtividade) {
                    this.$snack.success({ text: "Atividade atualizada com sucesso!" });
                }
            } catch (e) {
                this.$snack.error({ text: "Erro ao salvar a atividade." });
            }

        }
    }
}
</script>
